import Marquee from "react-fast-marquee";

export default function Ribbon() {
  return (
    <div className="border-y border-white/10 bg-[#08302D] py-6 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        <span className="font-display text-6xl md:text-8xl text-stroke mx-8">
          Energy · Heart Health · Antioxidant · Longevity ·
        </span>
      </Marquee>
    </div>
  );
}
